import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetMunicipalityOfficesByState() {
    const [getMunicipaltiesWithOfficesIsLoading, setGetMunicipaltiesWithOfficesIsLoading] = useState(false);
    const [getMunicipaltiesWithOfficesError, setGetMunicipaltiesWithOfficesError] = useState(null);
    const [municipaltiesWithOffices, setMunicipaltiesWithOffices] = useState([]);

    // Get the Parishes by Municipality

    const handleGetMunicipaltiesWithOfficesByState = useCallback(async (state) => {
        setGetMunicipaltiesWithOfficesIsLoading(true);
        setGetMunicipaltiesWithOfficesError(null);

        try {

            const officesRequest = await OptionsService.getMunicipaltiesWithOfficesByState(state);

            setGetMunicipaltiesWithOfficesIsLoading(false);
            setMunicipaltiesWithOffices(officesRequest?.data?.data);

        } catch(error) {

            setGetMunicipaltiesWithOfficesIsLoading(false);
            setGetMunicipaltiesWithOfficesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getMunicipaltiesWithOfficesIsLoading,
        getMunicipaltiesWithOfficesError,
        municipaltiesWithOffices,
        handleGetMunicipaltiesWithOfficesByState,
    }
}
